<template>
    <div class="create-director-fee"> 
        <validation-observer ref="createOrEditCertificateForm">
            <div class="px-1 mt-1">
                <fieldset class="p-1 mb-1" style="border:1px solid #D8D6DE;">
                    <legend visible="true" style="width:auto; margin-bottom: 0px; font-size: 14px; font-weight: 400; padding:0 3px; color:#5E5873;"> 
                        <h4> New Certificate </h4>
                    </legend>

                    <validation-provider
                        v-slot="{ errors }"
                        name="date"
                        rules="required"
                    >
                        <b-form-group label="Date" :state="errors.length > 0 ? false : null">
                            <flat-pickr
                                v-model="dataNewCertificate.date"
                                placeholder="Enter date"
                                class="form-control"
                                data-test="date"
                                :config="datePickerConfig"
                                :disabled="isDisabled"
                                :style="dynamicStyle"
                                :state="errors.length > 0 ? false : null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>

                    <validation-provider
                        v-slot="{ errors }"
                        name="certificate number"
                        rules="required"
                    >
                        <b-form-group label="Certificate Number">
                            <b-form-input
                                v-model="dataNewCertificate.number"
                                type="text"
                                placeholder="Enter certificate number"
                                :state="errors.length > 0 ? false : null"
                                data-test="certificate-number"
                                no-wheel
                                @keydown.up.prevent
                                @keydown.down.prevent
                            />

                        <small class="text-danger">{{ errors[0] }}</small>
                       </b-form-group> 
                    </validation-provider>

                    <validation-provider
                        v-slot="{ errors }"
                        name="number of shares"
                        rules="required"
                    >
                        <b-form-group label="Number of shares">
                            <b-form-input
                                id="number-of-shares"
                                v-model="dataNewCertificate.numberOfShares"
                                v-mask="shareMask"
                                autofocus
                                trim
                                placeholder="Enter number of shares"
                                type="text"
                                data-test ="name"
                                no-wheel
                                @keydown.up.prevent
                                @keydown.down.prevent
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>

                    <validation-provider
                        v-slot="{ errors }"
                        name="paid amount"
                        rules="required"
                    >
                        <b-form-group label="Total amount paid in respect of shares allotted">
                            <b-form-input
                                id="number-of-shares"
                                v-model="dataNewCertificate.paidUpShareCapital"
                                v-mask="amountMask"
                                autofocus
                                trim
                                placeholder="Enter number of shares"
                                type="text"
                                data-test ="name"
                                no-wheel
                                @keydown.up.prevent
                                @keydown.down.prevent
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>

                    <!-- form action -->
                    <div class="action-button d-flex justify-content-end mt-2">
                        <b-button  
                            v-if="newCertificateStatus !== 'view-director-fee'"  
                            class="mr-.5 d-flex align-items-center" 
                            variant="primary" 
                            data-test="update-or-create'create-new-certificate"
                            @click="updateOrCreate"
                        >
                            <span class="d-flex align-items-center text-nowrap">
                                {{  newCertificateStatus === 'create-new-certificate' ? 'Add' : 'Update' }}

                                <vector 
                                    v-if="newCertificateStatus === 'create-new-certificate'"
                                    data-name="add" 
                                    data-class="no-path-fill ml-.5 mb-.5" 
                                    data-width="22px"
                                    data-height="16px"
                                />

                                <img
                                    v-if="newCertificateStatus === 'edit-director-fee'"
                                    :src="'/illustrations/edit.svg'"
                                    class="ml-1"
                                    width="22px"
                                    height="16px"
                                    alt="edit-logo"
                                />

                            </span>
                        </b-button>
        
                        <b-button 
                            class="ml-1 d-flex align-items-center" 
                            variant="outline-danger" 
                            @click="$emit('cancel');"
                        >
                            Cancel
                            <vector 
                                data-type="icons" 
                                data-width="15px" 
                                data-height="15px" 
                                data-name="cancel" 
                                class="float-right ml-.5"
                                alt="cancel-logo"
                            />
                        </b-button>
                    </div>
                </fieldset>
            </div>   
        </validation-observer> 
    </div>
  </template>
  
<script>
import { BButton, BFormGroup, BFormInput } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import flatPickr from "vue-flatpickr-component";
import { NO_MATCHING_OPTIONS } from "@/constants/errors";
import { amountMask, shareMask } from "@/helpers";
  
export default {
    components:{
        BButton,
        BFormGroup,
        BFormInput,
        // BInputGroup,
        flatPickr,

        // vSelect,
        ValidationProvider,
        ValidationObserver,
    },

    props: {
        dataCertificate: {
            type: Object,
            required: true,
        },

        newCertificateStatus: {
            type: String,
            required: true,
            default: 'view-director-fee'
        },
    },
   

    data() {
        return {
            required,
            isFetching: false,
            NO_MATCHING_OPTIONS,
            amountMask,
            shareMask,

            dataNewCertificate: {
                _id: this.dataCertificate._id,
                date: this.dataCertificate.date,
                number: this.dataCertificate.number,
                numberOfShares: this.dataCertificate.numberOfShares,
                paidUpShareCapital: this.dataCertificate.paidUpShareCapital,
            },

            datePickerConfig: {
                altFormat: "j M Y",
                dateFormat: "j M Y",
                disableMobile: "true"
            },
        };
    },

    computed: {
        isDisabled() {
            return this.newCertificateStatus === 'view-new-certificate';
        },

        dynamicStyle() {
            if(this.dataStatus === "view-new-certificate")
                return "background: #efefef; cursor: context-menu!important";
            return "background: white;";
        },
    },

    created() {
        // this.setupCertificateLocal();
    },

    methods: {
        async setupCertificateLocal() {
            if(this.newCertificateStatus === 'create-new-certificate') {
                console.log('');
            }
        },

        updateOrCreate() {
            this.$refs.createOrEditCertificateForm.validate().then(success => {
                if (success) {
                    this.$emit('createOrUpdate', JSON.parse(JSON.stringify(this.dataNewCertificate)));

                    setTimeout(() => {
                        this.clearLocalData();
                    }, 300);
                }
            });
        },

        clearLocalData() {
            Object.keys(this.dataNewCertificate).forEach(key => {
                this.dataNewCertificate[key] = undefined;
            });
        },
    },
};
  
</script>


  